import 'bootstrap/dist/css/bootstrap.min.css';
import { Navigator, Main } from './components';
import './App.css';
import Amplify from 'aws-amplify';
import awsmobile from './aws-exports';
import { Authenticator, ThemeProvider } from '@aws-amplify/ui-react';
import { Provider } from 'react-redux'
import store from './components/store'

import { Theme } from './theme';


Amplify.configure(awsmobile);

const App = () => {
  return (
    <Authenticator.Provider>
      <Provider store={store}>
        <ThemeProvider
          theme={Theme}
          breakpoints={['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs']}
        >
          <Navigator />
          <Main />
        </ThemeProvider>
      </Provider>
    </Authenticator.Provider>
  );
}

export default App;